import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ThemeContext from '../../../theme/ThemeContext';

import { StyledFieldLabel } from './SettingsCommonElements';
import Icon from '../../misc/Icon';

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${(props) => props.theme.fontColorPrimary};
  margin-right: 4px;
  margin-bottom: 8px;
  background-color: transparent;
  padding: 6px 8px !important;
  font-size: 12px;
  border-radius: ${(props) => props.theme.borderRadius}px;
  border: 1px solid ${(props) => props.theme.borderColor};
  outline: unset; 
  transition: all 0.15s ease-in-out;

  &.active, &:focus {
    color: ${(props) => props.theme.fontColorPrimary};
    border: 1px solid ${(props) => props.theme.primaryColor};
  }

  &:hover {
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.primaryColor};
  }

  svg {
    font-size: 16px;
  }
`;

const StyledButtonLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
`;

function ButtonGroupSettings({
  id,
  label,
  types,
  onChange,
}) {

  const theme = useContext(ThemeContext);

  const buttons = types.map((item) => {

    if (!item) return null;

    const { icon, type, label, active, color } = item;

    const iconNode = icon ? <Icon icon={icon} /> : null;
    const textNode = label ? <StyledButtonLabel style={{ paddingLeft: icon ? '4px' : '0' }}>{label}</StyledButtonLabel> : '';

    return (
      <StyledButton
        key={type}
        theme={theme}
        className={active ? 'active' : ''}
        activeColor={color}
        active={active}
        onClick={(e) => {
          e.currentTarget.blur();
          onChange(type);
        }}
        data-testid={`${id}-type-${type}`}
      >
        {iconNode}
        {' '}
        {textNode}
      </StyledButton>
    );
  });

  return (
    <StyledWrapper>
      {!label ? null : <StyledFieldLabel htmlFor="ButtonGroupSettings">{label}</StyledFieldLabel>}
      <StyledButtonGroup id="ButtonGroupSettings" size="sm">
        {buttons}
      </StyledButtonGroup>
    </StyledWrapper>
  );

}

ButtonGroupSettings.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  types: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.any,
    label: PropTypes.string,
    active: PropTypes.bool,
    type: PropTypes.string,
    color: PropTypes.string
  })),
  onChange: PropTypes.func,
};

export default React.memo(ButtonGroupSettings);
